import { Component, Inject, OnInit } from '@angular/core';
import { StammdatenService } from '../../stammdaten.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../../../components/client/classes/client';

@Component({
    selector: 'kiene-hit-pin-aender-dialog',
    templateUrl: './hit-pin-aender-dialog.component.html',
    styleUrls: ['./hit-pin-aender-dialog.component.scss'],
})
export class HitPinAenderDialogComponent implements OnInit {
    constructor(
        private stammdatenService: StammdatenService,
        private messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) public kunde: Client,
        public dialogRef: MatDialogRef<HitPinAenderDialogComponent>,
    ) {}

    showPasswort = false;
    isSaving = false;
    neuePinCtrl: UntypedFormControl = new UntypedFormControl('', [Validators.required]);
    neuePinWdhCtrl: UntypedFormControl = new UntypedFormControl('', [Validators.required]);

    ngOnInit(): void {
        this.neuePinCtrl.valueChanges.subscribe(() => {
            this.resetErrors();
        });

        this.neuePinWdhCtrl.valueChanges.subscribe(() => {
            this.resetErrors();
        });
    }

    resetErrors() {
        this.neuePinCtrl.setErrors(null);
        this.neuePinWdhCtrl.setErrors(null);
    }

    checkPins() {
        if (this.neuePinCtrl.value === this.neuePinWdhCtrl.value) {
            this.resetErrors();
            return true;
        } else {
            this.neuePinCtrl.setErrors({ 'not-matching': true });
            this.neuePinWdhCtrl.setErrors({ 'not-matching': true });
            return false;
        }
    }

    pinAendern() {
        if (this.checkPins()) {
            this.isSaving = true;
            this.stammdatenService.hitPinAendern(this.kunde?.kunde_id, this.neuePinCtrl.value).subscribe({
                next: () => {
                    this.messageService.infoMessage('PIN erfolgreich geändert');
                    this.isSaving = false;
                    this.dialogRef.close();
                },
                error: err => {
                    this.messageService.errorMessage(
                        'PIN konnte nicht geändert werden.' + ' Ggf. stimmt PIN nicht mit PIN aus HIT überein.',
                        err,
                    );
                    this.isSaving = false;
                },
            });
        }
    }
}
